export default __webpack_public_path__ + "static/Sanitarie-ed33c58ec3a5e483227f7028d8734731.jpg";